import { SupportedChainId } from 'constants/chains'
import useHttpLocations from 'hooks/useHttpLocations'
import { useMemo } from 'react'
import { isAddress } from 'utils'

import HydraLogoWrapped from '../../assets/hydra/Hydra_Logo_Black.png'
import HydraLogo from '../../assets/hydra/Hydra_Logo_Blue.png'
import { isHydra, NATIVE_CHAIN_ID, nativeOnChain } from '../../constants/tokens'

type Network = 'hydrachain'

export function chainIdToNetworkName(networkId: SupportedChainId): Network {
  switch (networkId) {
    // SAMVI Unused: Mainly used for URLs with token logos, but we use custom URLs for token logos
    case SupportedChainId.HYDRA:
    case SupportedChainId.TESTNET:
    case SupportedChainId.DEVNET:
      return 'hydrachain'
    default:
      return 'hydrachain'
  }
}

export function getNativeLogoURI(chainId: SupportedChainId = SupportedChainId.HYDRA): string {
  switch (chainId) {
    case SupportedChainId.TESTNET:
    case SupportedChainId.DEVNET:
    case SupportedChainId.HYDRA:
      return HydraLogo
    default:
      return HydraLogo
  }
}

function getTokenLogoURI(address: string, chainId: SupportedChainId = SupportedChainId.HYDRA): string | void {
  // SAMVI Info: Urls for wrapped native tokens
  if (isHydra(chainId)) {
    if (address === nativeOnChain(chainId).wrapped.address) {
      return HydraLogoWrapped
    }
  }

  const networkName = chainIdToNetworkName(chainId)
  const networksWithUrls = [SupportedChainId.HYDRA]
  if (networksWithUrls.includes(chainId)) {
    return `https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/${networkName}/assets/${address}/logo.png`
  }
}

export function useCurrencyLogoURIs(
  currency:
    | {
        isNative?: boolean
        isToken?: boolean
        address?: string
        chainId: number
        logoURI?: string | null
      }
    | null
    | undefined
): string[] {
  const locations = useHttpLocations(currency?.logoURI)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative || currency.address === NATIVE_CHAIN_ID) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken || currency.address) {
        const checksummedAddress = isAddress(currency.address)
        const logoURI = checksummedAddress && getTokenLogoURI(checksummedAddress, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
